import Image from "next/image";
import React from "react";
import CocoCustomerService from "public/assets/coco-customer-service.svg";

import {
  CocoCircle,
  LabelStatus,
  LabelTitle,
  LabelWrapper,
  LauncherButton,
  LauncherWrapper,
  StatusDot,
  UnreadBadge
} from "./odoo-live-chat-launcher.styles";

interface IOdooLiveChatPillProps {
  // Null means unknown.
  isAvailable: boolean | null;
  unreadCount: number;
  isCollapsed: boolean;
  onClick: () => void;
}

// The pill launcher: the Coco circle with its label, which collapses to just
// the circle (unless there are unread replies).
export const OdooLiveChatPill: React.FC<IOdooLiveChatPillProps> = ({
  isAvailable,
  unreadCount,
  isCollapsed,
  onClick
}) => {
  const hasUnread = unreadCount > 0;
  const statusText = hasUnread
    ? "Ada balasan baru"
    : isAvailable === null
      ? "Memeriksa…"
      : isAvailable
        ? "Online"
        : "Offline";
  const isExpanded = !isCollapsed || hasUnread;

  return (
    <LauncherWrapper>
      <LauncherButton
        type="button"
        aria-label={`Chat Kakak Siaga, ${statusText}`}
        onClick={onClick}
      >
        <CocoCircle>
          <Image src={CocoCustomerService} alt="" fill />
          {hasUnread && (
            <UnreadBadge>{unreadCount > 99 ? "99+" : unreadCount}</UnreadBadge>
          )}
          <StatusDot $isOnline={isAvailable === true} />
        </CocoCircle>
        <LabelWrapper $isCollapsed={!isExpanded}>
          <LabelTitle>Chat Kakak Siaga</LabelTitle>
          <LabelStatus $isUnread={hasUnread}>{statusText}</LabelStatus>
        </LabelWrapper>
      </LauncherButton>
    </LauncherWrapper>
  );
};
